<template>
    <div @mouseleave="close">
        <Analytics v-if="options.site_analytics" :scripts="options.site_analytics" />

        <div :class="{ header: true, white: overlayHeader }">
            <div class="header_con">
                <a class="logo" href="/" @click.prevent="goPage('/index')" aria-label="富贵泉官网首页">
                    <img v-show="overlayHeader" :src="mainLogoSrc"
                        alt="富贵泉" @error="mainLogoFailed = true">
                    <img v-show="!overlayHeader" :src="secondLogoSrc"
                        alt="富贵泉" @error="secondLogoFailed = true">

                </a>
                <div class="menu">
                    <div :class="item.id" @mouseenter="(e) => getTab(e, item.id)" v-for="item in list" :key="item.id">
                        {{ item.name }}
                        <span class="line"></span>
                    </div>

                </div>
            </div>
            <div class="txt">
                <span>为老百姓造一辆好车</span>
                <div class="language-switch" data-testid="language-switch" aria-label="中英文切换">
                    <span class="active" aria-current="page">中</span>
                    <span class="divider">/</span>
                    <button type="button" @click="switchLanguage">EN</button>
                </div>
            </div>

        </div>
        <div class="right" :style="{right:tabName?'0.26042vw':0}">
                    <div role="button" tabindex="0" aria-label="打开 AI 智能客服"
                        @click="aiDialogVisible = true" @keydown.enter="aiDialogVisible = true">
                        <img src="@/assets/img/kefu2.png" alt="">
                        <span>AI 智能客服</span>
                    </div>
                    <router-link style="text-decoration: none;" :to="{ name: 'feadback' }" target="_blank">
                        <div class="feadback">
                            <img src="@/assets/img/feadback.png" alt="">
                            <span>反馈</span>
                        </div>
                    </router-link>

                    <div @click="top" class="goTop" v-show="scrollPosition > 800">
                        <img src="@/assets/img/top.png" alt="">
                        <span>回顶部</span>
                    </div>
                </div>
        <AiCustomerService :visible.sync="aiDialogVisible" />
        <headerMenu @close="close" :tabName="tabName" />
    </div>
</template>

<script>
import headerMenu from "@/components/headerMenu.vue"
import Analytics from "@/components/analytics.vue"
import AiCustomerService from "@/components/AiChatService.vue"

export default {
    components: {
        headerMenu,
        Analytics,
        AiCustomerService
    },
    data() {
        return {
            scrollPosition: 0,
            tabName: '',
            aiDialogVisible: false,
            mainLogoFailed: false,
            secondLogoFailed: false,
        }
    },
    computed: {
        pathName() {
            return this.$route.name
        },
        options() {
            return this.$store.state.dataInfo
        },
        list() {
            return this.$store.state.menuList.list
        },
        overlayHeader() {
            return this.scrollPosition <= 100 && !this.tabName && ['index', 'types', 'aboutUs'].includes(this.pathName)
        },
        mainLogoSrc() {
            return require('@/assets/img/logo2.png')
        },
        secondLogoSrc() {
            return require('@/assets/img/logo.png')
        }
    },
    watch:{
        tabName(n){
            if(n){
                document.body.style.overflow = 'hidden';
               
            }else{
                document.body.style.overflow = '';
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        top() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
        },
        handleScroll() {
            this.scrollPosition = window.scrollY
        },
        goPage(url) {
            if (url) {
                this.$router.push(url)
                this.$emit('close')
            }
            this.close()

        },
        getTab(e, name) {
            this.tabName = name
            const fgkj = document.querySelector(".fgkj");
            const fwzc = document.querySelector(".fwzc");
            const gywm = document.querySelector(".gywm");
            const tagRect = fgkj.getBoundingClientRect();
            const tagRect2 = fwzc.getBoundingClientRect();
            const tagRect3 = gywm.getBoundingClientRect();
            this.$store.commit('setOffset', {
                fgkj: tagRect,
                fwzc: tagRect2,
                gywm: tagRect3
            })
        },
        switchLanguage(){
            const isLocal = ['8080', '8082'].includes(window.location.port) || ['127.0.0.1', 'localhost'].includes(window.location.hostname)
            const target = isLocal
                ? `${window.location.protocol}//${window.location.hostname}:8082/`
                : 'https://en.fgqslc.com/'
            window.location.assign(target)
        },
        close() {
           this.tabName = ''
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    width: calc(100vw -  0.26042vw);
    height: 72px;
    padding: 0px 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: #fff;

    .header_con {
        display: flex;
        align-items: center;
        justify-content: center;

        .logo {
            cursor: pointer;
            width: 169px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .menu {
            margin-left: 28px;
            display: flex;
            align-items: center;
            justify-content: center;

            >div {
                position: relative;
                padding: 0 36px;
                font-weight: 400;
                font-size: 16px;
                color: #000000;
                cursor: pointer;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                height: 72px;

                .line {
                    position: absolute;
                    bottom: 0;
                    width: 79px;
                    background-color: #B00D16;
                    height: 3px;
                    display: none;

                }

                &:hover .line {
                    display: block;
                }

            }
        }
    }

    .txt {
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        align-items: center;
        justify-content: center;
        display: flex;

        >div {
            align-items: center;
            justify-content: center;
            display: flex;
        }

        .language-switch {
            gap: 6px;
            margin-left: 18px;
            padding: 6px 11px;
            border: 1px solid rgba(0, 0, 0, 0.35);
            border-radius: 999px;
            line-height: 1;
            white-space: nowrap;

            .active {
                color: #B00D16;
                font-weight: 700;
            }

            .divider {
                opacity: 0.45;
            }

            button {
                padding: 0;
                border: 0;
                background: transparent;
                color: inherit;
                font: inherit;
                cursor: pointer;
            }
        }

        img {
            cursor: pointer;
            width: 30px;
            height: 30px;
            margin-right: 15px;
        }
    }
}

.white {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0));
    color: #fff;

    .header_con {
        .menu {
            div {
                color: #fff;
            }
        }
    }

    .txt {
        color: #fff;

        .language-switch {
            border-color: rgba(255, 255, 255, 0.65);

            .active,
            button {
                color: #fff;
            }
        }
    }
}
.online {
    padding: 20px 5px;
    display: flex;

    img {
        width: 40px;
        height: 40px;
        margin-right: 20px;
        flex-shrink: 0;
    }

    div {
        display: flex;
        flex-direction: column;
        font-family: MiSans;
        font-weight: 400;
        font-size: 22px;
        width: 260px;

        p {
            margin: 0;
            padding: 0;
            color: #000;
        }

        .tel {
            margin: 5px 0;
            color: #B00D16;
        }

        .go {
            margin-top: 20px;
            color: #B00D16;
            font-weight: 500;
            font-size: 18px;
            cursor: pointer;
        }
    }
}

.right {
    width: 76px;
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 98;
    background-color: #fff;
    border-radius: 15px 0 0 10px;
    padding: 10px 6px 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    transition: all 0s;
    >div,
    .feadback {
        cursor: pointer;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        font-family: MiSans;
        font-weight: 400;
        font-size: 12px;
        color: #2c2c2c;
        margin-bottom: 15px;
        font-weight: bold;
        text-decoration: none;

        &:last-child {
            margin: 0;
        }

        &:first-child {
            img {
                width: 22px;
            }
        }

        span {
            text-decoration: none;
            text-align: center;
            line-height: 1.35;
        }

        img {
            width: 20px;
            height: auto;
            margin-bottom: 5px;

        }
    }

    .goTop {
        margin-top: 15px !important;
    }
}

</style>
